import React, {Component} from 'react'
import PropTypes from 'prop-types'
import StyleSheet from '../../styles'
import {authorizedLink} from '../../utils'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip/Tooltip'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import PrintIcon from '@material-ui/icons/Print'
import {IndexContext} from '..'
import qs from 'qs'
import {Authorization} from '../../utils'

export class IndexActions extends Component {
  static propTypes = {
    exportLink: PropTypes.any,
    filter: PropTypes.object,
    order: PropTypes.string,
  }

  get exportLink() {
    const {filter, order} = this.props
    const queryString = qs.stringify({filter, order}, {arrayFormat: 'brackets'})
    return authorizedLink(`${this.props.exportLink}?${queryString}`)
  }

  render = () =>
    <div className={styles.pageActions}>
      {Authorization.admin &&
      <a href={authorizedLink(this.exportLink)}>
        <Tooltip title="Export CSV">
          <IconButton><DownloadIcon/></IconButton>
        </Tooltip>
      </a>
      }
      {Authorization.admin &&
      <Tooltip title="Print">
        <IconButton onClick={() => window.print()}><PrintIcon/></IconButton>
      </Tooltip>
      }
    </div>
}

export default class PageActionsWrapper extends Component {
  render = () =>
    <IndexContext.Consumer>{value => <IndexActions {...value} {...this.props} />}</IndexContext.Consumer>
}

const styles = StyleSheet({
  pageActions: {
    flex: 1,
    textAlign: 'right',
    margin: [-2, 15, -2, 0],
    whiteSpace: 'nowrap'
  }
})

